<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Growing up on a farm in rural Devon, Lori developed a passion for books at an early age, absorbing a range of genres from crime/horror to fantasy and more. She loves the idea of travelling to different worlds without having to leave her home and started to envisage characters in her head who were outside of the norm.</p><br/>
<p style="text-indent:0em;">When she isn’t working full-time her hobbies also include woodworking, walking and acting in the local theatre group.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?10a984f1